import {
  Box,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import MuiInventory from "@mui/icons-material/Inventory";
import {
  SelectFormField,
  TextFormField,
} from "../../common/components/FormFields";

const PROFESSIONAL_RECOMMENDATION_HELP =
  "For example from a doctor, nurse, teacher, social worker, etc.";

function fieldId(namespace: string, field: string) {
  return `${namespace}-${field}`.replace(/[^a-zA-Z0-9_-]/g, "-");
}

export interface ItemFieldsProps {
  namespace: string;
}

export function ItemFields({ namespace }: ItemFieldsProps) {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const reasonId = fieldId(namespace, "reason");
  const descriptionId = fieldId(namespace, "description");
  const recommendationId = fieldId(namespace, "professional-recommendation");
  const recommendationLabelId = `${recommendationId}-label`;

  return (
    <Grid container spacing={1} flex={1}>
      <Grid item md={6} xs={12}>
        <TextFormField
          name={`${namespace}.name`}
          label="Item/service"
          required
          icon={<MuiInventory />}
        />
      </Grid>
      <Grid item md={6} xs={12}>
        <TextFormField
          name={`${namespace}.estimatedCost`}
          label="Estimated Cost"
          noIcon={md}
        />
      </Grid>
      <Grid item xs={12}>
        <TextFormField
          name={`${namespace}.reason`}
          label="Please provide details why this item/service is needed?"
          id={reasonId}
          required
          multiline
          noIcon
        />
      </Grid>
      <Grid item xs={12}>
        <TextFormField
          label="How will this item/service address an unmet need?"
          name={`${namespace}.description`}
          id={descriptionId}
          required
          multiline
          noIcon
        />
      </Grid>
      <Grid item xs={12}>
        <Stack direction="row" alignItems="center" gap={1}>
          <Box flex={1}>
            <SelectFormField
              label="Do you have a professional recommendation for this item/service?"
              name={`${namespace}.professionalRecommendation`}
              id={recommendationId}
              labelId={recommendationLabelId}
              options={["Yes", "No"]}
              required
              noIcon
            />
          </Box>
          <Tooltip title={PROFESSIONAL_RECOMMENDATION_HELP}>
            <IconButton
              type="button"
              aria-label={PROFESSIONAL_RECOMMENDATION_HELP}
              sx={{ p: 0.25 }}
            >
              <InfoOutlined aria-hidden="true" color="action" />
            </IconButton>
          </Tooltip>
        </Stack>
      </Grid>
    </Grid>
  );
}
